import {html, css, LitElement} from 'lit';


// Компонент создающий событие при выборе элемента и добавляющий класс selected.
// Может использоваться в dz-radio-select и dz-group-select

export class DzSelectable extends LitElement {

    static get properties() {
        return {
            disabled:   { type: Boolean, reflect: true },
            selected:   { type: Boolean, reflect: true },
            detail:     { type: String }
        }
    }

    constructor() {
        super()
        this.selected = false
    }

    connectedCallback() {
        super.connectedCallback()
        this.addEventListener("click", this.switch)

    }

    firstUpdated() {
        if (this.selected) {
            this.select(true)
        }
    }

    render() {
        return html`<slot></slot>`
    }

    selectChildren() {
        for (let child of this.children) {
            child.classList.add("selected")
        }
    }

    select(initial = false, make_evt = true) {
        if (!this.disabled) {
            this.selected = true
            this.selectChildren()
            if (make_evt) {
                let evt = new CustomEvent("select", {bubbles: true, composed: true, detail: this.detail})
                evt.source = this
                evt.initial = initial
                this.dispatchEvent(evt)
            }
        }
    }

    deselect(make_evt = true) {
        if (!this.disabled) {
            this.selected = false
            for (let child of this.children) {
                child.classList.remove("selected")
            }
            if (make_evt) {
                let evt = new CustomEvent("deselect", {bubbles: true, composed: true, detail: this.detail})
                evt.source = this
                this.dispatchEvent(evt)
            }
        }
    }

    switch() {
        if (this.selected) {
            this.deselect()
        } else {
            this.select()
        }
    }

    static styles = css`
        :host([disabled]) {
            pointer-events: none;
            opacity: 0.3;
        }
    `
}

customElements.define('dz-selectable', DzSelectable)
